import 'zone.js';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { installGlobalErrorHandling, showSystemError } from './app/error-handler';

enableProdMode();
installGlobalErrorHandling();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error(err);
    showSystemError(500, 'angular-bootstrap');
  });
